export default {
  "name": "Sounds",
  "assets": [
    {
      "file": "sounds/beep1.ogg",
      "name": "Beep 1",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263128/"
    },
    {
      "file": "sounds/beep2.ogg",
      "name": "Beep 2",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263126/"
    },
    {
      "file": "sounds/blip1.ogg",
      "name": "Blip 1",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/405546/"
    },
    {
      "file": "sounds/blip2.ogg",
      "name": "Blip 2",
      "icon": "icons/sound.png",
      "credit": "User Leszek_Szary on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Leszek_Szary/sounds/146727/"
    },
    {
      "file": "sounds/blip3.ogg",
      "name": "Blip 3",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263132/"
    },
    {
      "file": "sounds/blip4.ogg",
      "name": "Blip 4",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263124/"
    },
    {
      "file": "sounds/blip5.ogg",
      "name": "Blip 5",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263129/"
    },
    {
      "file": "sounds/click1.ogg",
      "name": "Click 1",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/483600/"
    },
    {
      "file": "sounds/fwipp.ogg",
      "name": "Fwipp",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/405547/"
    },
    {
      "file": "sounds/gameBump1.ogg",
      "name": "Game Bump 1",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/483602/"
    },
    {
      "file": "sounds/longBeep1.ogg",
      "name": "Long Beep 1",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263130/"
    },
    {
      "file": "sounds/longBeep2.ogg",
      "name": "Long Beep 2",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263127/"
    },
    {
      "file": "sounds/poof.ogg",
      "name": "Poof",
      "icon": "icons/sound.png",
      "credit": "User: Planman on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Planman/sounds/208111/"
    },
    {
      "file": "sounds/stone1.ogg",
      "name": "Stone 1",
      "icon": "icons/sound.png",
      "credit": "User: Mediaman57 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Mediaman57/sounds/347149/"
    },
    {
      "file": "sounds/stone2.ogg",
      "name": "Stone 2",
      "icon": "icons/sound.png",
      "credit": "User: ertfelda on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/ertfelda/sounds/243699/"
    },
    {
      "file": "sounds/thump.ogg",
      "name": "Thump",
      "icon": "icons/sound.png",
      "credit": "User OtisJames on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/OtisJames/sounds/249613/"
    },
    {
      "file": "sounds/thunk.ogg",
      "name": "Thunk",
      "icon": "icons/sound.png",
      "credit": "User jameswrowles on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/jameswrowles/sounds/380640/"
    },
    {
      "file": "sounds/woop1.ogg",
      "name": "Woop 1",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/483604/"
    },
    {
      "file": "sounds/woop2.ogg",
      "name": "Woop 2",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/483603/"
    },
    {
      "file": "sounds/woop3.ogg",
      "name": "Woop 3",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/405548/"
    },
    {
      "file": "sounds/woosh.ogg",
      "name": "Woosh",
      "icon": "icons/sound.png",
      "credit": "User freakinbehemoth on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/freakinbehemoth/sounds/243400/"
    },
    {
      "file": "sounds/wrong1.ogg",
      "name": "Wrong 1",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/483598/"
    },
    {
      "file": "sounds/wrong2.ogg",
      "name": "Wrong 2",
      "icon": "icons/sound.png",
      "credit": "User pan14 on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/pan14/sounds/263123/"
    },
    {
      "file": "sounds/zhoop.ogg",
      "name": "Zhoop",
      "icon": "icons/sound.png",
      "credit": "User Raclure on Freesound.org",
      "license": "Creative Commons 0 License",
      "licenseLink": "https://creativecommons.org/publicdomain/zero/1.0/",
      "link": "https://freesound.org/people/Raclure/sounds/483608/"
    }
  ]
}
